import get from 'lodash-es/get';
import omit from 'lodash-es/omit';
import pick from 'lodash-es/pick';
import merge from 'lodash-es/merge';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import updateClass from '../css/updateClass';
import uniqueId from '../uniqueId';
import frameProps from '../css/frameProps';
import defaults from './frame.defaults';
import each from 'lodash-es/each';
import {renderControls} from '../renderControls';
import getDisabledStyle from '../css/disabledStyle';
import Control from './control';

function updateFrameClasses(control, options) {
  let normal = get(options, 'style.normal',{});
  let title = get(options, 'title.style.normal',{});
  let scheme = lookAndFeel(options.lookAndFeel, normal.height);
  let CSS = updateStyleByRef(
    merge(cloneDeep(defaults.cssClass), [
      {
        // body
        properties: omit(normal, frameProps),
      },
      {
        // title
        properties: title,
      },
    ]),
    scheme
  );

  if (isEqual(control.CSS, CSS)) {
    return;
  }

  control.CSS = CSS;
  control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);
}

export default class Frame extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this, 'text', () =>
      this._checkDataOption('text', get(this._controlOptions,'title.text','')),
      { formatter:'titleFormatter' }
    );
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    // const options = this.options;
    const instance = this.instance;
    const path = this.path;

    if (!control.el) {
      control.el = defaults.createElement();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-frame-',Frame);
        control.styleSheet = 'css-' + control.id;
      }else{
        control.el.setAttribute('id',control.id);
      }

      delete control.strOptions;
    }

    const strOptions = JSON.stringify(options, (k, v) => {
      if (k !== 'grid') {
        return v;
      }
    });

    if (control.strOptions !== strOptions) {
      updateFrameClasses(control, options);
      control.strOptions = strOptions;
      //var bodyEl = control.el.getElementsByClassName('body')[0];
      var stylePatch = {};
      merge(stylePatch, defaults.cssStyle.normal);

      if (options.style && options.style.normal) {
        merge(stylePatch, pick(options.style.normal, frameProps));
      }

      merge(stylePatch, control.frameStyle);

      if (control.disabled) {
        merge(stylePatch, getDisabledStyle());
        if (options.style && options.style.disabled) {
          merge(stylePatch, options.style.disabled);
        }

        if (control.isLayoutMode) {
          delete stylePatch.pointerEvents;
        }
      }

      let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
      // console.log('scheme', options.lookAndFeel, scheme);
      updateStyleByRef([stylePatch], scheme);

      if (instance.options.chartSize && options.layout && options.layout != 'custom') {
        const [x, y] = options.layout.split(',');
        const [w, h] = instance.options.chartSize.split('x');
        const i = (x - 1) * h + (y - 1) * 1;
        const { top, right, bottom, left } = instance.options.grid[i];
        merge(stylePatch, {
          top,
          right,
          bottom,
          left,
          width: 'auto',
          height: 'auto',
        });
      }

      updateStyle(control.el, stylePatch, control.currentStyle);
      control.currentStyle = stylePatch;
      const titleEl = control.el.getElementsByClassName('title')[0];
      titleEl.innerHTML = control.text; // get(options, 'title.text') || '';
      titleEl.classList.remove('top', 'right', 'bottom', 'left');
      titleEl.classList.add(get(options, 'title.position') || 'top');
    }

    if (options.controls) {
      each(options.controls, function(ctrl) {
        ctrl.lookAndFeel = merge({}, options.lookAndFeel, ctrl.lookAndFeel);
        if (!ctrl.style) {
          ctrl.style = {};
        }

        ctrl.style.normal = merge({}, ctrl.style.normal, {
          pointerEvents: 'auto',
        });
      });
      renderControls(instance, path,control.nicePath, control.el);
    }

    return control.el;
  }
}
